import React from 'react';
import { Link } from 'react-router-dom';
import { Field,  reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, FormActions, Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, waitingListStatusTypes, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='child.name' component={Static} horizontal label={t('WaitingList_Child')} />
			<Field name='parent.name' component={Static} horizontal label={t('WaitingList_Parent')} />
			<Field name='term.name' component={Static} horizontal label={t('WaitingList_Term')} />
			<Field name='center.name' component={Static} horizontal label={t('WaitingList_Center')} />
			<Field name='grade.name' component={Static} horizontal label={t('WaitingList_Grade')} />

			<Field name='statusId' component={Input} componentClass='select' horizontal required label={t('WaitingList_Status')} validate={validators.required}>
				<option />
				{ui.makeOptionValues(waitingListStatusTypes)}
			</Field>
			<FormActions horizontal>
				<Link to='/waitingList' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'waitingListDetails', enableReinitialize: true })(withTranslation()(SettingsForm));
